export const DELAY_OPTIONS = [
	{ label: 'Αμέσως', value: 0 },
	{ label: 0.5, value: 0.5 },
	{ label: 1, value: 1 },
	{ label: 2, value: 2 },
	{ label: 3, value: 3 },
	{ label: 5, value: 5 },
	{ label: 7, value: 7 },
	{ label: 10, value: 10 },
	{ label: 15, value: 15 },
	{ label: 20, value: 20 },
	{ label: 25, value: 25 },
	{ label: 30, value: 30 },
	{ label: 40, value: 40 },
	{ label: 50, value: 50 },
	{ label: '1 ώρα', value: 60 },
	{ label: '1:15', value: 75 },
	{ label: '1.30', value: 90 },
	{ label: '1:45', value: 105 },
	{ label: '2 ώρες', value: 120 },
];

// Upper bound for a hand-typed preparation time. Matches the last DELAY_OPTIONS
// entry and the backend's MAX_ORDER_DELAY_MINUTES.
export const MAX_ORDER_DELAY_MINUTES = 120;

export const DISPLAY_OPTIONS = {
	FULL: 'full',
	ORDERS: 'orders',
	// MAP_ONLY: 'map-only',
};

export const PAYMENT_TYPES = {
	CASH: 'cash',
	CARD: 'card',
};

export const DECLINED_ORDER_WOLT_DRIVE_BEHAVIOR_OPTIONS = {
	SEND_INTERNAL: 'send-internal',
	ABORT: 'abort',
};

export const SEARCH_ORDER_FIELDS = {
	SHOP_NAME: 'shop-name',
	CLIENT: 'client',
	ADDDRESS: 'address',
	DELIVERY: 'delivery',
	COMMENTS: 'comments',
};

// Who put a rider on an order — the distinction `adminAssigned` cannot make,
// since it is true for an admin AND for the automatic check. Mirrors ASSIGNED_BY
// in the backend's util/constants.js. Null on orders that predate the column.
export const ASSIGNED_BY = {
	ADMIN: 'admin',
	AUTO: 'auto',
	SELF: 'self',
	WOLT: 'wolt',
};
